import React from 'react';
import { motion } from 'framer-motion';
import { PenTool, Monitor, Image as ImageIcon, MapPin } from 'lucide-react';

const services = [
  { title: "Illuminated Signs", icon: <Monitor size={40} />, desc: "Custom channel letters and light boxes that make your business shine 24/7." },
  { title: "Monument Signs", icon: <MapPin size={40} />, desc: "High-impact, durable architectural signage for property entrances." },
  { title: "Window Graphics", icon: <ImageIcon size={40} />, desc: "Eye-catching vinyl decals and perforated window films for storefronts." },
  { title: "Custom Awnings", icon: <PenTool size={40} />, desc: "Hand-painted and custom-designed canopies to elevate your exterior." }
];

const Services = () => {
  return (
    <section id="services" className="py-32 bg-brand-light relative">
      <div className="container mx-auto px-6 md:px-12">
        
        <div className="text-center mb-20">
          <h2 className="text-5xl font-black text-brand-dark mb-4 uppercase tracking-tight">Our <span className="text-brand-blue">Expertise</span></h2>
          <div className="w-32 h-1.5 bg-gradient-to-r from-brand-blue to-brand-cyan mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white p-10 rounded-3xl shadow-[0_10px_40px_rgba(0,0,0,0.05)] border-b-4 border-transparent hover:border-brand-cyan hover:-translate-y-2 transition-all duration-300 group relative overflow-hidden"
            >
              {/* Hover Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-brand-cyan/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              <div className="w-20 h-20 bg-brand-light text-brand-blue rounded-2xl flex items-center justify-center mb-8 group-hover:bg-brand-blue group-hover:text-brand-cyan transition-colors duration-300 relative z-10">
                {service.icon}
              </div>
              <h3 className="text-2xl font-black text-brand-dark mb-4 relative z-10">{service.title}</h3>
              <p className="text-gray-500 font-medium leading-relaxed relative z-10">{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;